import { TTripDestination } from "../TripDestinations"

export interface IDocType {
	id: number
	name: string
	destinations: TTripDestination[]
	deleted_at?: null | string
}
export interface IDocTypeUpdate extends Omit<IDocType, "destinations"> {
	destinations: number[]
}

export const supportedDocuemntTypes = [
	"image/png",
	"image/jpg",
	"image/jpeg",
	"application/pdf",
]
